import { useState } from "react";

export default (apiFunc) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const request = async (...args) => {
        setLoading(true);
        try {
            const result = await apiFunc(...args);
            setData(result.data || result);
        } catch (err) {
            setError(err.message || "Unexpected Error!");
        } finally {
            setLoading(false);
        }
    };

    const requestPromise = (...args) => {
        return new Promise(async (resolve, reject) => {
            setLoading(true);
            try {
                const result = await apiFunc(...args);
                setData(result.data || result);
                resolve(result.data || result);
            } catch (err) {
                setError(err.message || "Unexpected Error!");
                reject(err)
            } finally {
                setLoading(false);
                resolve(data)
            }
        })
    };

    return {
        data,
        error,
        loading,
        request,
        requestPromise
    };
};
